import { listOf1jh22dvmctj1r as listOf } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { EnumType11cgb4df0n5r9 as EnumType } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CompiledGraphQL.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { enumEntries20mr21zbe3az4 as enumEntries } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/enums/EnumEntries.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var AvatarType_Retro_instance;
var AvatarType_RobohashSet1_instance;
var AvatarType_RobohashSet2_instance;
var AvatarType_RobohashSet3_instance;
var AvatarType_RobohashSet4_instance;
var AvatarType_RobohashSet5_instance;
var AvatarType_Multiavatar_instance;
var AvatarType_DicebearPixelArt_instance;
var AvatarType_DicebearAdventurer_instance;
var AvatarType_DicebearCroodles_instance;
var AvatarType_DicebearThumbs_instance;
var AvatarType_DicebearLorelei_instance;
var AvatarType_UNKNOWN___instance;
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.y6n_1 = new (EnumType())('AvatarType', listOf(['Retro', 'RobohashSet1', 'RobohashSet2', 'RobohashSet3', 'RobohashSet4', 'RobohashSet5', 'Multiavatar', 'DicebearPixelArt', 'DicebearAdventurer', 'DicebearCroodles', 'DicebearThumbs', 'DicebearLorelei']));
      }
      m6o(rawValue) {
        // Inline function 'kotlin.collections.find' call
        var tmp0 = get_entries();
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlin.collections.firstOrNull' call
          var _iterator__ex2g4s = tmp0.p1();
          while (_iterator__ex2g4s.q1()) {
            var element = _iterator__ex2g4s.r1();
            if (element.p6o_1 === rawValue) {
              tmp$ret$1 = element;
              break $l$block;
            }
          }
          tmp$ret$1 = null;
        }
        var tmp0_elvis_lhs = tmp$ret$1;
        return tmp0_elvis_lhs == null ? AvatarType_UNKNOWN___getInstance() : tmp0_elvis_lhs;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  AvatarType_initEntries();
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
function values() {
  return [AvatarType_Retro_getInstance(), AvatarType_RobohashSet1_getInstance(), AvatarType_RobohashSet2_getInstance(), AvatarType_RobohashSet3_getInstance(), AvatarType_RobohashSet4_getInstance(), AvatarType_RobohashSet5_getInstance(), AvatarType_Multiavatar_getInstance(), AvatarType_DicebearPixelArt_getInstance(), AvatarType_DicebearAdventurer_getInstance(), AvatarType_DicebearCroodles_getInstance(), AvatarType_DicebearThumbs_getInstance(), AvatarType_DicebearLorelei_getInstance(), AvatarType_UNKNOWN___getInstance()];
}
function get_entries() {
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values());
  return $ENTRIES;
}
var AvatarType_entriesInitialized;
function AvatarType_initEntries() {
  if (AvatarType_entriesInitialized)
    return Unit_instance;
  AvatarType_entriesInitialized = true;
  AvatarType_Retro_instance = new (AvatarType())('Retro', 0, 'Retro');
  AvatarType_RobohashSet1_instance = new (AvatarType())('RobohashSet1', 1, 'RobohashSet1');
  AvatarType_RobohashSet2_instance = new (AvatarType())('RobohashSet2', 2, 'RobohashSet2');
  AvatarType_RobohashSet3_instance = new (AvatarType())('RobohashSet3', 3, 'RobohashSet3');
  AvatarType_RobohashSet4_instance = new (AvatarType())('RobohashSet4', 4, 'RobohashSet4');
  AvatarType_RobohashSet5_instance = new (AvatarType())('RobohashSet5', 5, 'RobohashSet5');
  AvatarType_Multiavatar_instance = new (AvatarType())('Multiavatar', 6, 'Multiavatar');
  AvatarType_DicebearPixelArt_instance = new (AvatarType())('DicebearPixelArt', 7, 'DicebearPixelArt');
  AvatarType_DicebearAdventurer_instance = new (AvatarType())('DicebearAdventurer', 8, 'DicebearAdventurer');
  AvatarType_DicebearCroodles_instance = new (AvatarType())('DicebearCroodles', 9, 'DicebearCroodles');
  AvatarType_DicebearThumbs_instance = new (AvatarType())('DicebearThumbs', 10, 'DicebearThumbs');
  AvatarType_DicebearLorelei_instance = new (AvatarType())('DicebearLorelei', 11, 'DicebearLorelei');
  AvatarType_UNKNOWN___instance = new (AvatarType())('UNKNOWN__', 12, 'UNKNOWN__');
  Companion_getInstance();
}
var $ENTRIES;
var AvatarTypeClass;
function AvatarType() {
  if (AvatarTypeClass === VOID) {
    class $ extends Enum() {
      constructor(name, ordinal, rawValue) {
        super(name, ordinal);
        this.p6o_1 = rawValue;
      }
    }
    initMetadataForClass($, 'AvatarType');
    AvatarTypeClass = $;
  }
  return AvatarTypeClass;
}
function AvatarType_Retro_getInstance() {
  AvatarType_initEntries();
  return AvatarType_Retro_instance;
}
function AvatarType_RobohashSet1_getInstance() {
  AvatarType_initEntries();
  return AvatarType_RobohashSet1_instance;
}
function AvatarType_RobohashSet2_getInstance() {
  AvatarType_initEntries();
  return AvatarType_RobohashSet2_instance;
}
function AvatarType_RobohashSet3_getInstance() {
  AvatarType_initEntries();
  return AvatarType_RobohashSet3_instance;
}
function AvatarType_RobohashSet4_getInstance() {
  AvatarType_initEntries();
  return AvatarType_RobohashSet4_instance;
}
function AvatarType_RobohashSet5_getInstance() {
  AvatarType_initEntries();
  return AvatarType_RobohashSet5_instance;
}
function AvatarType_Multiavatar_getInstance() {
  AvatarType_initEntries();
  return AvatarType_Multiavatar_instance;
}
function AvatarType_DicebearPixelArt_getInstance() {
  AvatarType_initEntries();
  return AvatarType_DicebearPixelArt_instance;
}
function AvatarType_DicebearAdventurer_getInstance() {
  AvatarType_initEntries();
  return AvatarType_DicebearAdventurer_instance;
}
function AvatarType_DicebearCroodles_getInstance() {
  AvatarType_initEntries();
  return AvatarType_DicebearCroodles_instance;
}
function AvatarType_DicebearThumbs_getInstance() {
  AvatarType_initEntries();
  return AvatarType_DicebearThumbs_instance;
}
function AvatarType_DicebearLorelei_getInstance() {
  AvatarType_initEntries();
  return AvatarType_DicebearLorelei_instance;
}
function AvatarType_UNKNOWN___getInstance() {
  AvatarType_initEntries();
  return AvatarType_UNKNOWN___instance;
}
//region block: exports
export {
  AvatarType as AvatarTypedvyblcabyk2y,
  Companion_getInstance as Companion_getInstance10logk9fbwg04,
};
//endregion

//# sourceMappingURL=AvatarType.mjs.map
